import type { RouteObject } from "react-router";

import { ChangePasswordPage } from "./change-password-page.js";
import { ConfirmEmailFailedPage, ConfirmEmailPage, ConfirmEmailSuccessPage } from "./confirm-email-pages.js";
import { DeleteCompletedPage, DeletePage } from "./delete-pages.js";
import { DisableTwoFactorPage } from "./disable-two-factor-page.js";
import {
    ChangeEmailConfirmationPage, ChangeEmailConfirmPage, ChangeEmailFailedPage, ShowWaitChangeEmailPage,
} from "./email-change-pages.js";
import { VerifyEmailCodePage } from "./email-code-pages.js";
import { EnableTotpPage } from "./enable-totp-page.js";
import { LoginPage } from "./login-page.js";
import { LockoutPage } from "./message-pages.js";
import { NeedsLogoutPage } from "./needs-logout-page.js";
import {
    ForgotPasswordConfirmationPage, ForgotPasswordPage, ResetPasswordConfirmationPage, ResetPasswordPage,
} from "./password-pages.js";
import { RegisterPage, ShowWaitMessagePage } from "./register-pages.js";
import { AccountSettingsPage } from "./settings-page.js";
import { VerifyTotpPage } from "./verify-totp-page.js";

/** アカウント（ログイン・登録・設定）。<b>足したら paths/account.json にも足す。</b> */
export const accountRoutes: RouteObject[] = [
    { path: "/Account/Login", element: <LoginPage /> },
    { path: "/Account/VerifyTotpLogin", element: <VerifyTotpPage /> },
    { path: "/Account/EnableTotp", element: <EnableTotpPage /> },
    { path: "/Account/VerifyEmailCode", element: <VerifyEmailCodePage /> },
    { path: "/Account/Lockout", element: <LockoutPage /> },
    // 招待を別のアカウントで開いたとき。URL は今のアプリ（ErrorController）と同じ
    { path: "/Error/NeedsLogout", element: <NeedsLogoutPage /> },

    { path: "/Account", element: <AccountSettingsPage /> },
    { path: "/Account/Index", element: <AccountSettingsPage /> },
    { path: "/Account/DisableTwoFactor", element: <DisableTwoFactorPage /> },

    { path: "/Account/Register", element: <RegisterPage /> },
    { path: "/Account/ShowWaitMessage", element: <ShowWaitMessagePage /> },
    { path: "/Account/ConfirmEmail", element: <ConfirmEmailPage /> },
    { path: "/Account/ConfirmEmailSuccess", element: <ConfirmEmailSuccessPage /> },
    { path: "/Account/ConfirmEmailFailed", element: <ConfirmEmailFailedPage /> },

    { path: "/Account/ForgotPassword", element: <ForgotPasswordPage /> },
    { path: "/Account/ForgotPasswordConfirmation", element: <ForgotPasswordConfirmationPage /> },
    { path: "/Account/ResetPassword", element: <ResetPasswordPage /> },
    { path: "/Account/ResetPasswordConfirmation", element: <ResetPasswordConfirmationPage /> },
    { path: "/Account/ChangePassword", element: <ChangePasswordPage /> },

    { path: "/Account/ShowWaitChangeEmail", element: <ShowWaitChangeEmailPage /> },
    { path: "/Account/ChangeEmailConfirm", element: <ChangeEmailConfirmPage /> },
    { path: "/Account/ChangeEmailConfirmation", element: <ChangeEmailConfirmationPage /> },
    { path: "/Account/ChangeEmailFailed", element: <ChangeEmailFailedPage /> },

    { path: "/Account/Delete", element: <DeletePage /> },
    { path: "/Account/DeleteCompleted", element: <DeleteCompletedPage /> },
];
